module.exports = __webpack_public_path__ + "media/images/iso-9001-e0d3b7a8811ecb40c82f876ed80000d8.jpg";